import { defineEvent } from '@itc/shared';
import { z } from 'zod';
import { EntryKind, Origin } from './schemas.ts';

// The bank's public events (plan 5D, Chunk 1), for the modules that record entries through
// its calls and want to hear how they ended. Published in the same commit as the change
// that settles the entry (the outbox, D10), so "it happened" and "it's told" can't disagree.

/** How an entry another module recorded ended. `completed`: money moved. `declined`: it was rejected or cancelled and never will. `reversed`: a completed entry was reversed. */
export const EntryOutcome = z.enum(['completed', 'declined', 'reversed']);
export type EntryOutcome = z.infer<typeof EntryOutcome>;

/**
 * An entry that has an origin, one a module recorded through a call, was settled: it
 * completed, it was declined, or it was reversed. Never published for an entry recorded
 * in the bank itself, and published once for each ending. `entryId` and `kind` are the
 * entry the module recorded, also when the outcome is `reversed`; `origin` is the module
 * and the key it recorded it with, which is how the module finds what this is about.
 */
export const EntrySettled = defineEvent({
  type: 'bank.entry_settled',
  data: z.object({ entryId: z.string(), origin: Origin, kind: EntryKind, outcome: EntryOutcome }),
});
export type EntrySettled = z.infer<typeof EntrySettled.data>;
